import { render, staticRenderFns } from "./ActivityPlaceholder.vue?vue&type=template&id=68c2dc5a&scoped=true"
import script from "./ActivityPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ActivityPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2dc5a",
  null
  
)

export default component.exports